import { Pipe, PipeTransform } from '@angular/core';
import { EmulatorMessage, EmulatorMessageTypes } from '../../../../../shared/models';

@Pipe({ name: 'isUserMessage' })
export class IsUserMessagePipe implements PipeTransform {

  transform(emulatorMessage: EmulatorMessage, ...args: unknown[]): boolean {
    return emulatorMessage.messageType === EmulatorMessageTypes.MESSAGE_REPLY ||
      emulatorMessage.messageType === EmulatorMessageTypes.START;
  }

}
